import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from "../../../../common/api"
import { CLUSTERS, CLUSTERS_ADD, CLUSTERS_DETAILS } from '../../../../common/constant'

export const actionClusters = createAsyncThunk('appClustersSlice/actionClusters', async (params, thunkAPI) => {
    return await post(CLUSTERS, params, thunkAPI)
})

export const actionAddClusters = createAsyncThunk('appClustersSlice/actionAddClusters', async (params, thunkAPI) => {
    return await post(CLUSTERS_ADD, params, thunkAPI)
})

export const actionGetCluster = createAsyncThunk('appClustersSlice/actionGetCluster', async (params, thunkAPI) => {
    return await post(CLUSTERS_DETAILS, params, thunkAPI)
})

export const appClustersSlice = createSlice({
    name: 'appClustersSlice',
    initialState: {
        loadingClusters: false,
        clusters: null,

        loadingAddClusters: false,
        addClusters: null,

        loadingGetCluster: false,
        clusterDetails: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetClustersResponse: (state) => {
            state.clusters = null
        },

        resetAddClustersResponse: (state) => {
            state.addClusters = null
        },

        resetClusterDetailResponse: (state) => {
            state.clusterDetails = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionClusters.pending, (state) => {
                state.loadingClusters = true
            })
            .addCase(actionClusters.fulfilled, (state, action) => {
                state.loadingClusters = false
                state.clusters = action.payload
            })
            .addCase(actionClusters.rejected, (state) => {
                state.loadingClusters = false
            })
            //Add
            .addCase(actionAddClusters.pending, (state) => {
                state.loadingAddClusters = true
            })
            .addCase(actionAddClusters.fulfilled, (state, action) => {
                state.loadingAddClusters = false
                state.addClusters = action.payload
            })
            .addCase(actionAddClusters.rejected, (state) => {
                state.loadingAddClusters = false
            })
            //Details
            .addCase(actionGetCluster.pending, (state) => {
                state.loadingGetCluster = true
            })
            .addCase(actionGetCluster.fulfilled, (state, action) => {
                state.loadingGetCluster = false
                state.clusterDetails = action.payload
            })
            .addCase(actionGetCluster.rejected, (state) => {
                state.loadingGetCluster = false
            })
    }
})
export const { resetClustersResponse, resetAddClustersResponse, resetClusterDetailResponse } = appClustersSlice.actions

export default appClustersSlice.reducer